import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Button, Flex, Modal, WhiteSpace, WingBlank } from 'antd-mobile'
import _ from 'lodash'
import { closeWebView, openNative } from 'utils'

export default class Tips extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true
    }
  }

  handleClick = (viewUrl) => {
    if (viewUrl) {
      if (viewUrl.indexOf('leaveWeb') !== -1) {
        return closeWebView()
      }
      if (_.startsWith(viewUrl, 'route://native')) {
        openNative(viewUrl)
      }
      if (_.startsWith(viewUrl, 'http')) {
        window.location.replace(viewUrl)
      }
    }
    this.props.onClose()
  }

  render() {
    const {
      tipsInfo = {},
      showBizData = false,
      wrapClassName,
      showCloseBtn = false
    } = this.props
    console.log(tipsInfo)
    const { redirectView = [] } = tipsInfo // type === 'Display'不展示弹窗
    return (
      <Modal
        visible={this.state.visible}
        wrapClassName={`${classes.componentsTips} ${wrapClassName}`}
        transitionName='fade'
        maskTransitionName='fade'
        maskClosable={false}
      >
        <div className={`text-center no-scroll-bar ${classes.content}`}>
          {_.size(tipsInfo) ? (
            <React.Fragment>
              <WhiteSpace />
              <WhiteSpace />
              <WingBlank>
                {!showBizData && (
                  <React.Fragment>
                    <img
                      src={tipsInfo.tipImg || 'https://alioss.payby.com/cms/icon.png'}
                      width='80'
                    />
                    <WhiteSpace size='lg' />
                  </React.Fragment>
                )}
                {tipsInfo.title ? (
                  <React.Fragment>
                    <p className='tips-title'>
                      <b>{tipsInfo.title}</b>
                    </p>
                    <WhiteSpace size='sm' />
                    <p className='font-sm' style={{ lineHeight: '17px' }}>
                      {tipsInfo.tipText}
                    </p>
                  </React.Fragment>
                ) : (
                  <p className={classes.tipText}>{tipsInfo.tipText}</p>
                )}
                <WhiteSpace />
              </WingBlank>
              {/* 业务数据 */}
              {this.props.children}
              <WhiteSpace />

              {!!_.size(redirectView) && (
                <div className='am-button-wrap'>
                  <WingBlank>
                    <Flex justify='center'>
                      {redirectView.map((item) => (
                        <Flex.Item
                          key={item.viewName}
                          className={_.size(redirectView) === 1 && classes.single}
                        >
                          <Button
                            type={item.viewType}
                            name='custom'
                            className='font-sm'
                            onClick={() => this.handleClick(item.viewUrl)}
                          >
                            <b>{item.viewName}</b>
                          </Button>
                        </Flex.Item>
                      ))}
                    </Flex>
                    <WhiteSpace />
                    <WhiteSpace />
                  </WingBlank>
                </div>
              )}
            </React.Fragment>
          ) : (
            this.props.children
          )}
        </div>

        {showCloseBtn && (
          <React.Fragment>
            <WhiteSpace size='xl' />
            <WhiteSpace size='lg' />
            <img
              src={require('./images/close.png')}
              width='36'
              onClick={this.props.onClose}
            />
          </React.Fragment>
        )}
      </Modal>
    )
  }
}

/**
  @tipsInfo  通用组件信息
  @showBizData  是否展示业务数据
  @wrapClassName 自定义组件样式类名
  @showCloseBtn 是否展示关闭按钮
  @onClose  关闭弹窗回调
**/
